var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0366 4.7636C15.3881 5.11508 15.3881 5.68492 15.0366 6.0364L7.83659 13.2364C7.48512 13.5879 6.91527 13.5879 6.5638 13.2364L2.9638 9.6364C2.61233 9.28492 2.61233 8.71508 2.9638 8.3636C3.31527 8.01213 3.88512 8.01213 4.23659 8.3636L7.2002 11.3272L13.7638 4.7636C14.1153 4.41213 14.6851 4.41213 15.0366 4.7636Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.804117278b3ea022e6bbc08d0203e7ce.svg";
export { ForwardRef as ReactComponent };